import { render } from "./DescriptionAndObjectivesHeatingOfLenta.vue?vue&type=template&id=3a2fbea0&scoped=true"
import script from "./DescriptionAndObjectivesHeatingOfLenta.vue?vue&type=script&lang=js"
export * from "./DescriptionAndObjectivesHeatingOfLenta.vue?vue&type=script&lang=js"

import "./DescriptionAndObjectivesHeatingOfLenta.vue?vue&type=style&index=0&id=3a2fbea0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2fbea0"]])

export default __exports__